import React from 'react';

function PrivacyPolicy() {
    return (
        <div className="privacy-container">
            <div className="privacy-header">
                <h1>Privacy Policy</h1>
            </div>

            <div className="privacy-content">
                <div className="privacy-intro">
                    <p>This privacy policy sets out how E-Tech uses and protects any information that you give E-Tech when you use this website. E-Tech is committed to ensuring that your privacy is protected. Should we ask you to provide certain information by which you can be identified when using this website, then you can be assured that it will only be used in accordance with this privacy statement. E-Tech may change this policy from time to time by updating this page. You should check this page from time to time to ensure that you are happy with any changes.</p>
                </div>

                <section className="privacy-section">
                    <h2>What we collect</h2>
                    <p>We may collect the following information:</p>
                    <ul>
                        <li>name</li>
                        <li>contact information including email address</li>
                        <li>demographic information such as postcode, preferences and interests</li>
                        <li>other information relevant to customer surveys and/or offers</li>
                    </ul>
                    <p>For the exhaustive list of cookies we collect see the List of cookies we collect section below.</p>
                </section>

                <section className="privacy-section">
                    <h2>What we do with the information we gather</h2>
                    <p>We require this information to understand your needs and provide you with a better service, and in particular for the following reasons:</p>
                    <ul>
                        <li>Internal record keeping.</li>
                        <li>We may use the information to improve our products and services.</li>
                        <li>We may periodically send promotional emails about new products, special offers or other information which we think you may find interesting using the email address which you have provided.</li>
                        <li>From time to time, we may also use your information to contact you for market research purposes. We may contact you by email, phone, fax or mail. We may use the information to customise the website according to your interests.</li>
                    </ul>
                </section>

                <section className="privacy-section">
                    <h2>Security</h2>
                    <p>We are committed to ensuring that your information is secure. In order to prevent unauthorised access or disclosure, we have put in place suitable physical, electronic and managerial procedures to safeguard and secure the information we collect online.</p>
                </section>

                <section className="privacy-section">
                    <h2>How we use cookies</h2>
                    <p>A cookie is a small file which asks permission to be placed on your computer's hard drive. Once you agree, the file is added and the cookie helps analyse web traffic or lets you know when you visit a particular site. Cookies allow web applications to respond to you as an individual. The web application can tailor its operations to your needs, likes and dislikes by gathering and remembering information about your preferences.</p>
                    <p>We use traffic log cookies to identify which pages are being used. This helps us analyse data about web page traffic and improve our website in order to tailor it to customer needs. We only use this information for statistical analysis purposes and then the data is removed from the system.</p>
                    <p>Overall, cookies help us provide you with a better website, by enabling us to monitor which pages you find useful and which you do not. A cookie in no way gives us access to your computer or any information about you, other than the data you choose to share with us. You can choose to accept or decline cookies. Most web browsers automatically accept cookies, but you can usually modify your browser setting to decline cookies if you prefer. This may prevent you from taking full advantage of the website.</p>
                </section>

                <section className="privacy-section">
                    <h2>Links to other websites</h2>
                    <p>Our website may contain links to other websites of interest. However, once you have used these links to leave our site, you should note that we do not have any control over that other website. Therefore, we cannot be responsible for the protection and privacy of any information which you provide whilst visiting such sites and such sites are not governed by this privacy statement. You should exercise caution and look at the privacy statement applicable to the website in question.</p>
                </section>

                <section className="privacy-section">
                    <h2>Controlling your personal information</h2>
                    <p>You may choose to restrict the collection or use of your personal information in the following ways:</p>
                    <ul>
                        <li>whenever you are asked to fill in a form on the website, look for the box that you can click to indicate that you do not want the information to be used by anybody for direct marketing purposes</li>
                        <li>if you have previously agreed to us using your personal information for direct marketing purposes, you may change your mind at any time by writing to or emailing us at <a href="mailto:info@e-tech.ie">info@e-tech.ie</a></li>
                    </ul>
                    <p>We will not sell, distribute or lease your personal information to third parties unless we have your permission or are required by law to do so. We may use your personal information to send you promotional information about third parties which we think you may find interesting if you tell us that you wish this to happen.</p>
                    <p>You may request details of personal information which we hold about you under the Data Protection Act 1998. A small fee will be payable. If you would like a copy of the information held on you please write to E-Tech, 1 Ballinteer Road, Dundrum, Dublin 16.</p>
                    <p>If you believe that any information we are holding on you is incorrect or incomplete, please write to or email us as soon as possible, at the above address. We will promptly correct any information found to be incorrect.</p>
                </section>

                <section className="privacy-section">
                    <h2>List of cookies we collect</h2>
                    <p>The table below lists the cookies we collect and what information they store.</p>
                    <div className="cookie-table-wrapper">
                        <table className="cookie-table">
                            <thead>
                                <tr>
                                    <th>Cookie Name</th>
                                    <th>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>CART</td>
                                    <td>The association with your shopping cart.</td>
                                </tr>
                                <tr>
                                    <td>CATEGORY_INFO</td>
                                    <td>Stores the category info on the page, that allows to display pages more quickly.</td>
                                </tr>
                                <tr>
                                    <td>COMPARE</td>
                                    <td>The items that you have in the Compare Products list.</td>
                                </tr>
                                <tr>
                                    <td>CURRENCY</td>
                                    <td>Your preferred currency</td>
                                </tr>
                                <tr>
                                    <td>CUSTOMER</td>
                                    <td>An encrypted version of your customer id with the store.</td>
                                </tr>
                                <tr>
                                    <td>CUSTOMER_AUTH</td>
                                    <td>An indicator if you are currently logged into the store.</td>
                                </tr>
                                <tr>
                                    <td>CUSTOMER_INFO</td>
                                    <td>An encrypted version of the customer group you belong to.</td>
                                </tr>
                                <tr>
                                    <td>CUSTOMER_SEGMENT_IDS</td>
                                    <td>Stores the Customer Segment ID</td>
                                </tr>
                                <tr>
                                    <td>EXTERNAL_NO_CACHE</td>
                                    <td>A flag, which indicates whether caching is disabled or not.</td>
                                </tr>
                                <tr>
                                    <td>FRONTEND</td>
                                    <td>You sesssion ID on the server.</td>
                                </tr>
                                <tr>
                                    <td>GUEST-VIEW</td>
                                    <td>Allows guests to edit their orders.</td>
                                </tr>
                                <tr>
                                    <td>LAST_CATEGORY</td>
                                    <td>The last category you visited.</td>
                                </tr>
                                <tr>
                                    <td>LAST_PRODUCT</td>
                                    <td>The most recent product you have viewed.</td>
                                </tr>
                                <tr>
                                    <td>NEWMESSAGE</td>
                                    <td>Indicates whether a new message has been received.</td>
                                </tr>
                                <tr>
                                    <td>NO_CACHE</td>
                                    <td>Indicates whether it is allowed to use cache.</td>
                                </tr>
                                <tr>
                                    <td>PERSISTENT_SHOPPING_CART</td>
                                    <td>A link to information about your cart and viewing history if you have asked the site.</td>
                                </tr>
                                <tr>
                                    <td>POLL</td>
                                    <td>The ID of any polls you have recently voted in.</td>
                                </tr>
                                <tr>
                                    <td>POLLN</td>
                                    <td>Information on what polls you have voted on.</td>
                                </tr>
                                <tr>
                                    <td>RECENTLYCOMPARED</td>
                                    <td>The items that you have recently compared.</td>
                                </tr>
                                <tr>
                                    <td>STF</td>
                                    <td>Information on products you have emailed to friends.</td>
                                </tr>
                                <tr>
                                    <td>STORE</td>
                                    <td>The store view or language you have selected.</td>
                                </tr>
                                <tr>
                                    <td>USER_ALLOWED_SAVE_COOKIE</td>
                                    <td>Indicates whether a customer allowed to use cookies.</td>
                                </tr>
                                <tr>
                                    <td>VIEWED_PRODUCT_IDS</td>
                                    <td>The products that you have recently viewed.</td>
                                </tr>
                                <tr>
                                    <td>WISHLIST</td>
                                    <td>An encrypted list of products added to your Wishlist.</td>
                                </tr>
                                <tr>
                                    <td>WISHLIST_CNT</td>
                                    <td>The number of items in your Wishlist.</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </section>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
